// Mongo: 909.706ms

export function filterAttributesForComponent(attributes, componentType, subPageType) {
    switch (componentType) {
        case "Summary":
        case "Table":
        case "Cards":
        case "List":
        case "Calendar":
        case "Kanban":
            return attributes.filter((x) =>
                x.attributeType === "Mirror" ? x.attribute.attributeType !== "Html" : x.attributeType !== "Html"
            );
        case "Form":
            return subPageType === "New Record"
                ? attributes.filter(attribute => !attribute.isSystemAttribute)
                : attributes
        default:
            return attributes;
    }
}

export function reorderData(data, activeItem, dataItem, direction) {
    if (activeItem === dataItem) {
        return data;
    }
    const reorderedData = data.slice();
    let prevIndex = reorderedData.findIndex((p) => p.attributeId === activeItem.attributeId);
    let nextIndex = reorderedData.findIndex((p) => p.attributeId === dataItem.attributeId) + (direction === "before" ? -1 : 0);
    if (prevIndex > nextIndex) {
        nextIndex++;
    }
    reorderedData.splice(prevIndex, 1);
    reorderedData.splice(nextIndex, 0, activeItem || reorderedData[0]);
    return reorderedData;
}

export function reorderDataForFormAndView(data, activeItem, droppedItem, direction) {
    // Find the index of activeItem and droppedItem in the data array.
    const activeIndex = data.findIndex((item) => item.attributeId === activeItem.attributeId);
    const droppedIndex = data.findIndex((item) => item.attributeId === droppedItem.attributeId);

    // Check for invalid input or direction.
    if (
        activeIndex < 0 ||
        activeIndex >= data.length ||
        droppedIndex < 0 ||
        droppedIndex >= data.length ||
        (direction !== "before" && direction !== "after")
    ) {
        // Return the original data if input is invalid.
        return data;
    }

    // Check if activeItem and droppedItem belong to the same group.
    if (activeItem.group === droppedItem.group) {
        const newData = data.slice();

        newData.splice(activeIndex, 1);

        // Calculate the new index for activeItem.
        let newIndex = droppedIndex;

        newData.splice(newIndex, 0, activeItem);

        return newData;
    } else {
        // Items belong to different groups.

        // Find all items with the same group as activeItem, sorted by attributeId.
        const elementsWithActiveItemGroup = data
            .filter((item) => item.group === activeItem.group)
            .sort((a, b) => (a.attributeId === activeItem.attributeId ? -1 : 1));

        // Filter out items that belong to the activeItem group.
        const filteredData = data.filter((item) => item.group !== activeItem.group);

        // if item is dragged above its original position. example: 8 -> 3
        if (activeIndex > droppedIndex) {
            // Find the first element with the droppedItem group and insert before it.
            const firstElementWithDroppedItemGroupIndex = filteredData.findIndex(
                (item) => item.group === droppedItem.group
            );
            filteredData.splice(firstElementWithDroppedItemGroupIndex, 0, elementsWithActiveItemGroup);
        } else {
            // if item is dragged below its original position. example: 3 -> 8
            // Find the last element with the droppedItem group and insert after it.
            const lastElementWithDroppedItemGroupIndex = filteredData
                .slice()
                .reverse()
                .findIndex((item) => item.group === droppedItem.group);
            const insertIndex = filteredData.length - lastElementWithDroppedItemGroupIndex;
            filteredData.splice(insertIndex, 0, elementsWithActiveItemGroup);
        }

        // Flatten the filtered data to return the updated data.
        return filteredData.flat();
    }

    // Return the updated data.
    return data;
}

export function handleAttributeGroupChange(data, attribute, newGroup) {
    const newAttributeData = { ...attribute, group: newGroup };
    const reorderedData = data.slice().filter((element) => element.attributeId !== attribute.attributeId);
    // find last element of the new group
    const lastElement = reorderedData.slice().reverse().find((element) => element.group === newGroup);
    if (lastElement) {
        const nextIndex = reorderedData.findIndex((p) => p.attributeId === lastElement.attributeId) + 1;
        reorderedData.splice(nextIndex, 0, newAttributeData);
    } else {
        reorderedData.push(newAttributeData);
    }
    return reorderedData;
}